import React from 'react';

import DataConnector from 'connect/DataConnector';
import OnboardingConstants from 'constants/OnboardingConstants';
import * as SpaceUtil from 'growth/SpaceUtil';
import HomeDashboardStore from 'home-dashboard/HomeDashboardStore';
import ChecklistItemListing from 'onboarding/ChecklistItemListing';
import {
  NUEModuleEnhancedProps,
  OnboardingTask,
  SEQUENCE_CHECKLIST_KEY,
  SEQUENCE_CHECKLIST_TITLE,
} from 'onboarding/OnboardingConstants';
import {makeSequenceListItems, trackChecklistCollapsed} from 'onboarding/OnboardingUtils';
import EntityStore from 'stores/EntityStore';

class SequenceNUEModuleConnector extends DataConnector<{}, NUEModuleEnhancedProps> {
  shouldSubscribeToRedux = false;
  stores = [HomeDashboardStore];

  enhanceProps(): NUEModuleEnhancedProps {
    const sequenceModule = this.homeDashboardStore().getNUEModuleState(OnboardingConstants.MODULES.SEQUENCE);
    return {
      collapsed: sequenceModule?.collapsed ?? false,
      completed: sequenceModule?.completed ?? false,
      openIndex: sequenceModule?.openIndex ?? null,
      tasks: sequenceModule?.tasks ?? null,
      visible: !sequenceModule?.acknowledgedCompleted && !sequenceModule?.dismissed,
    };
  }
}

function handleChangeCollapsed(isCollapsed: boolean): void {
  trackChecklistCollapsed(isCollapsed, SEQUENCE_CHECKLIST_KEY, SEQUENCE_CHECKLIST_TITLE);
}

function SequenceNUEModule({
  tasks,
  completed,
  visible,
  collapsed,
  openIndex,
}: NUEModuleEnhancedProps): JSX.Element {
  const currentUser = EntityStore.currentUser();
  const canEarnSpace = currentUser && !SpaceUtil.hasUnlimitedSpace(currentUser);

  let listItems: Array<OnboardingTask> = [];
  if (visible && currentUser && tasks) {
    listItems = makeSequenceListItems(tasks, completed ?? false, canEarnSpace);
  }

  return (
    <>
      {listItems.length !== 0 && (
        <ChecklistItemListing
          collapsed={collapsed!}
          completed={completed}
          listItems={listItems}
          module={OnboardingConstants.MODULES.SEQUENCE}
          openIndex={openIndex}
          title="Explore Molecular Biology"
          onChangeCollapsed={handleChangeCollapsed}
          fixedSize={true}
        />
      )}
    </>
  );
}

export default SequenceNUEModuleConnector.connect(SequenceNUEModule);
